// Secciones cuyo acceso se asigna de forma granular por usuario.
// Las claves DEBEN coincidir con backend/src/services/authService.js (VALID_SECTIONS).
//
// =========================================================================
// 📝 GUÍA PARA AGREGAR NUEVOS MÓDULOS / VEHÍCULOS AL CONTROL DE PERMISOS:
// =========================================================================
// Si en el futuro se agregan más módulos (ej. "Camioneta C", "Caja Nueva"),
// debés seguir estos 4 pasos para que figuren en "Editar Usuario" y control:
//
// 1️⃣ En BACKEND (backend/src/services/authService.js):
//    Agregá la nueva clave string (ej. 'viajes_camioneta_xx') al array VALID_SECTIONS.
//
// 2️⃣ En FRONTEND (frontend/src/config/permissions.js - este archivo):
//    Agregá el objeto con { key: 'viajes_camioneta_xx', label: 'Nombre Vista', desc: 'Descripción' }
//    dentro del array SECTIONS.
//
// 3️⃣ En FRONTEND (frontend/src/App.jsx):
//    Protegé la ruta del módulo envolviendo el componente con:
//    <ProtectedRoute permission="viajes_camioneta_xx"> ... </ProtectedRoute>
//
// 4️⃣ En FRONTEND (frontend/src/components/layout/Layout.jsx):
//    Condicioná el enlace en el sidebar usando la función can:
//    ...(can('viajes_camioneta_xx') ? [{ name: '...', href: '...' }] : [])
// =========================================================================

export const SECTIONS = [
  { key: 'buscar', label: 'Buscar personas', desc: 'Buscador general por DNI o nombre, con la ficha completa de cada persona' },
  { key: 'beneficiarios', label: 'Beneficiarios', desc: 'Padrón completo de asistencias entregadas, con exportación a Excel' },
  { key: 'reclamos', label: 'Reclamos ciudadanos', desc: 'Alumbrado, residuos, poda y calles: el formulario web y la carga a mano, sin DNI' },
  { key: 'instituciones', label: 'Instituciones', desc: 'Escuelas, iglesias, clubes y comisiones vecinales: sus pedidos. El total por institución lo ve un administrador' },
  { key: 'comedores', label: 'Comedores', desc: 'Operación en la sede: padrón de chicos (con su hogar) y asistencia diaria en el salón' },
  { key: 'comedores_admin', label: 'Administración de Comedores', desc: 'Red de sedes, entrega de mercadería, gastos fijos y costo real por ración' },
  { key: 'caja_celiacos', label: 'Caja Celíacos', desc: 'Control de cajas celíacos' },
  { key: 'tarjeta_sapucay', label: 'Tarjeta Sapucay', desc: 'Control de Tarjetas Sapucay' },
  { key: 'kit_femenino', label: 'Kit Femenino', desc: 'Planilla mensual de kits femeninos (hasta 200 por mes), con las personas de cada kit' },
  { key: 'tarjeta_mama_mbarete', label: 'Tarjeta Mamá Mbareté', desc: 'Padrón de embarazadas con Tarjeta Mamá Mbareté (cobertura provincial, $50.000/mes)' },
  { key: 'vales', label: 'Vales para Retirar', desc: 'Registro y notas de vales de retiro' },
  { key: 'inundaciones', label: 'Inundaciones / Evacuados', desc: 'Planilla de evacuados por inundaciones y mapa de riesgo' },
  { key: 'mesa_entrada', label: 'Mesa de Entrada', desc: 'Gestión y seguimiento de trámites, solicitudes y reclamos' },
  { key: 'whatsapp', label: 'WhatsApp', desc: 'Bandeja de mensajes de WhatsApp (experimental, número de prueba)' },
  { key: 'emprendedores', label: 'Emprendedores', desc: 'Padrón de emprendedores locales y gestión de ayudas/subsidios' },
  { key: 'el_nino', label: 'Fenómeno El Niño', desc: 'Relevamiento social por inundación: mapa de riesgo e indicadores (sistema aparte)' },
  { key: 'analytics', label: 'Analytics', desc: 'Dashboard ejecutivo y estadísticas' },
  { key: 'logs', label: 'Logs y auditoría', desc: 'Registro de acciones del sistema' },
  { key: 'revision_duplicados', label: 'Revisión de duplicados', desc: 'Duplicados cruzados Hospital/Social' },
  { key: 'tipos_asistencia', label: 'Tipos de asistencia', desc: 'Configurar categorías y opciones' },
  { key: 'viajes_corrientes', label: 'Combi Corrientes', desc: 'Planilla semanal Corrientes' },
  { key: 'viajes_goya', label: 'Combi Goya', desc: 'Planilla semanal Goya' },
  { key: 'viajes_camioneta_mn', label: 'Camioneta AF802MN', desc: 'Planilla semanal Camioneta AF802MN' },
  { key: 'viajes_camioneta_mo', label: 'Camioneta AF802MO', desc: 'Planilla semanal Camioneta AF802MO' },
  { key: 'viajes_colectivo', label: 'Colectivo', desc: 'Planilla semanal Colectivo (33 butacas, destino variable por día)' },
  { key: 'viajes_camion', label: 'Camión', desc: 'Planilla semanal Camión (30 espacios, destino variable por día)' },
  { key: 'viajes_captiva', label: 'Chevrolet Captiva', desc: 'Planilla semanal Chevrolet Captiva (6 lugares, destino variable por día)' },
  { key: 'viajes_padron', label: 'Padrón Viajes', desc: 'Padrón de pasajeros' },
  { key: 'capacitaciones', label: 'Capacitaciones', desc: 'Planilla de capacitaciones y asistencia de los participantes' },
  { key: 'produccion', label: 'Producción', desc: 'Entregas de semillas, plantines y abonos a vecinos (Dirección de Producción)' },
  { key: 'osint', label: 'Revisión de fuentes', desc: 'Consultar y verificar información de fuentes externas' },
  { key: 'observatorio_ia', label: 'Observatorio', desc: 'Grafo de conocimiento, vínculos inferidos y alertas de duplicidad' },
]

export const SECTION_KEYS = SECTIONS.map((s) => s.key)
/** Pantalla de inicio: el buscador si lo tiene habilitado, si no el Panel. */
export const homePath = (user) => (hasSection(user, 'buscar') ? '/buscar' : '/panel')

export const sectionLabel = (key) => SECTIONS.find((s) => s.key === key)?.label || key

/** ¿Es administrador por rol? (gestiona usuarios) */
export function isAdmin(user) {
  const r = String(user?.rol || '').trim().toLowerCase()
  return r === 'admin' || r === 'administrator'
}

/** ¿Tiene acceso total? (admin por rol o módulo administrativo) */
export function hasFullAccess(user) {
  if (isAdmin(user)) return true
  const m = String(user?.modulo || '').trim().toLowerCase()
  return m === 'administracion' || m === 'total'
}

/** ¿El usuario puede acceder a una sección granular? */
export function hasSection(user, key) {
  if (hasFullAccess(user)) return true
  const perms = Array.isArray(user?.permisos) ? user.permisos : []
  if (perms.includes(key)) return true
  // Si el usuario tiene acceso a cualquier vehículo de transporte, otorgar acceso a Colectivo y Camión automáticamente
  const hasTransport = perms.some((p) => String(p).startsWith('viajes_'))
  if (hasTransport && (key === 'viajes_colectivo' || key === 'viajes_camion' || key === 'viajes_captiva')) {
    return true
  }
  return false
}
